import { render, staticRenderFns } from "./auth-base-login.vue?vue&type=template&id=1bc9f9c2&scoped=true&"
import script from "./auth-base-login.vue?vue&type=script&lang=ts&"
export * from "./auth-base-login.vue?vue&type=script&lang=ts&"
import style0 from "./auth-base-login.vue?vue&type=style&index=0&id=1bc9f9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc9f9c2",
  null
  
)

export default component.exports